@if (disableControls && sliderOptions) {
  <div [pTooltip]="tooltipContent" class="text-color-secondary" showDelay="300">
    @if (sliderOptions.maxValue) {
      {{ sliderOptions.minValue }} - {{ sliderOptions.maxValue }}
    } @else {
      {{ sliderOptions.minValue }}
    }
  </div>

  <ng-template #tooltipContent>
    <div class="flex align-items-baseline gap-2">
      <i class="fas fa-info-circle"></i> Jahresnavigation für diese Ansicht
      deaktiviert
    </div>
  </ng-template>
} @else {
  <div [style]="{ width: '30rem' }" class="flex gap-3 align-items-center">
    @if (allowOneYearFocusDropdown) {
      <button
        pButton
        type="button"
        class="flex-shrink-0"
        icon="fas fa-thumbtack"
        size="small"
        [rounded]="true"
        [outlined]="true"
        pTooltip="Jahr fixieren"
        tooltipPosition="bottom"
        aria-label="Jahr fixieren"
        (click)="yearMenu.toggle($event)"></button>
      <p-menu #yearMenu [model]="yearMenuItems" [popup]="true" appendTo="body">
        <ng-template pTemplate="start">
          <div class="px-3 pt-2 pb-1 text-sm text-color-secondary">
            Jahr fixieren
          </div>
        </ng-template>
      </p-menu>
    }
    @if (availableYears.length > 1) {
      @if (sliderOptions && sliderOptions.options) {
        @if (sliderOptions.maxValue) {
          <ngx-slider
            [value]="sliderOptions.minValue"
            [highValue]="sliderOptions.maxValue"
            [options]="sliderOptions.options"
            (userChangeEnd)="setNewYears($event)"></ngx-slider>
        } @else {
          <ngx-slider
            [value]="sliderOptions.minValue"
            [options]="sliderOptions.options"
            (userChangeEnd)="setNewYears($event)"></ngx-slider>
        }
      }
    } @else if (sliderOptions) {
      <div class="ml-auto text-color-secondary">
        {{ sliderOptions.minValue }}
      </div>
    }
  </div>
}
